import React from 'react'
import BlogCard from '../PageComponents/Blog/BlogCard'
import MetaTags from '../components/MetaTags';

const Blog = () => {
  // document.title="Blogs | Positive Metering"
  document.title="Dosing Pump Blog UAE | Industry Insights & Guides | MENA"
  const metaDetails = {
    title: 'Dosing Pump Blog UAE | Industry Insights & Guides | MENA',
    description: 'Explore expert blogs on dosing pumps, applications, and industrial solutions in UAE and MENA. Learn about water treatment, oil & gas, and chemical dosing systems.',
  keywords: 'Metering Pump Manufacturer in India',
    slug: '',
      alt: 'Dosing Pump Blog - Insights on Chemical Dosing Systems & Industrial Pumps',
  };

  return (
    <div className='mb-4'>
      <MetaTags
      title={metaDetails.title}
      description={metaDetails.description}
      keywords={metaDetails.keywords}
      slug={metaDetails.slug}
      alt={metaDetails.alt}
    />
      <BlogCard />
    </div>
  )
}

export default Blog